import AdminCRUD from "@/components/admin/AdminCRUD";

const empty = { name: "", description: "", phone: "", phone_href: "", web: "", category: "crisis", order: 0 };
const fields = [
  { name: "name", label: "Name", type: "text", required: true, placeholder: "e.g. 988 Suicide & Crisis Lifeline" },
  {
    name: "category", label: "Category", type: "select", required: true,
    options: [
      { value: "crisis", label: "Crisis Support" },
      { value: "support", label: "Family & Community Support" },
      { value: "treatment", label: "Treatment & Harm Reduction" },
    ],
  },
  { name: "description", label: "Description", type: "textarea", rows: 3 },
  { name: "phone", label: "Phone (display)", type: "text", placeholder: "e.g. 988 or 1-800-662-HELP (4357)" },
  { name: "phone_href", label: "Phone (tel: link)", type: "text", placeholder: "e.g. tel:988 or tel:18006624357" },
  { name: "web", label: "Website URL", type: "text", placeholder: "https://..." },
];

export default function AdminResources() {
  return (
    <AdminCRUD
      title="Resources"
      description="Crisis lines, support orgs, and treatment info shown on the Resources page."
      endpoint="resources"
      emptyItem={empty}
      fields={fields}
      itemLabel={(r) => r.name || "(no name)"}
      itemSubtitle={(r) => r.category + (r.phone ? " · " + r.phone : "")}
    />
  );
}
